module.exports = __webpack_public_path__ + "assets/asset_plane.69a91a93.svg";